import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetDomiciliosByCompany = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/domicilios/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getDomiciliosByCompanyMutation: mutation.mutate,
    };
}